<template>
  <b-modal :active="active" has-modal-card @close="close">
    <div class="modal-card" style="width: 900px; height: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ $t('compCarbonFormsUploadErrors.error-msg-title') }}
        </p>
      </header>
      <section class="modal-card-body">
        <b-tabs type="is-boxed">
          <b-tab-item :label="$t('compCarbonFormsUploadErrors.tab-errors')">
            <my-notification
              :closable="false"
              has-icon
              icon="warning"
              v-if="criticalError"
            >
              <template #title>
                {{ $t('compCarbonFormsUploadErrors.' + criticalError.message) }}
              </template>
              <p
                v-if="criticalError.params"
                v-html="
                  $t(
                    'compCarbonFormsUploadErrors.' +
                      `${criticalError.message}.info`,
                    translateParams(criticalError.params)
                  )
                "
              ></p>
              <p
                v-else
                v-html="
                  $t(
                    'compCarbonFormsUploadErrors.' +
                      `${criticalError.message}.info`
                  )
                "
              ></p>
            </my-notification>

            <div v-if="!criticalError">
              <my-notification
                v-for="(errorLines, key) in parsingErrors"
                :key="key"
                :closable="false"
                has-icon
                icon="warning"
              >
                <template #title>
                  {{ $t('compCarbonFormsUploadErrors.' + key) }}
                </template>
                <p>
                  <i
                    >{{
                      $t('compCarbonFormsUploadErrors.in-the-following-lines')
                    }}:
                  </i>
                  <span
                    v-for="(el, index) in errorLines.slice(0, 10)"
                    :key="index"
                  >
                    <b-tooltip dashed multilined append-to-body type="is-black">
                      <template #content>
                        <p
                          v-html="
                            $t(
                              'compCarbonFormsUploadErrors.' + `${key}.info`,
                              el
                            )
                          "
                        ></p>
                      </template>
                      <a>{{ el.row + 2 }}</a>
                    </b-tooltip>
                    <span v-if="index != errorLines.length - 1">
                      <span v-if="index === 9"
                        >...[{{ errorLines.length }}
                        {{
                          $t('compCarbonFormsUploadErrors.total-errors')
                        }}]</span
                      >
                      <span v-else>, </span>
                    </span>
                  </span>
                </p>
                <hr />
              </my-notification>
            </div>
          </b-tab-item>
          <b-tab-item :label="$t('compCarbonFormsUploadErrors.tab-help')">
            <component :is="formatImportName" />
          </b-tab-item>
        </b-tabs>
      </section>
    </div>
  </b-modal>
</template>

<script>
import Vue from 'vue'
import {
  CriticalParsingError,
  ERROR_GENERIC,
  ParsingErrors
} from '../../../utils/parser'

export default {
  name: 'UploadErrors',
  props: {
    error: {
      type: Error,
      default: null
    },
    module: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'my-notification': () => import('@/components/MyNotification.vue')
  },
  data () {
    return {
      displayFormatError: false,
      criticalError: null,
      parsingErrors: []
    }
  },
  computed: {
    formatImportName: function () {
      return this.module + 'HelpFileFormat'
    }
  },
  methods: {
    translateParams: function (params) {
      // generate a human readable string (and translated)
      if (params['column']) {
        return {
          column: this.$t(
            'compCarbonFormsUploadErrors.' +
              `error-msg-col.${this.module}.${params['column']}`
          )
        }
      }
      return params
    },
    close: function () {
      this.criticalError = null
      this.parsingErrors = []
      this.$emit('close')
    }
  },
  watch: {
    error: function () {
      if (!this.error) {
        this.criticalError = null
        this.parsingErrors = []
        return
      }
      if (this.error instanceof CriticalParsingError) {
        this.criticalError = this.error
      } else if (this.error instanceof ParsingErrors) {
        this.parsingErrors = this.error.toObject()
      } else {
        this.criticalError = new CriticalParsingError(ERROR_GENERIC)
      }
    }
  },
  beforeMount () {
    Vue.component(
      this.formatImportName,
      // A dynamic import returns a Promise.
      () =>
        import(
          '@/components/carbon/forms/' + this.module + '/HelpFileFormat.vue'
        )
    )
  }
}
</script>
